import { Effect } from 'effect';

import { reactivityKeys } from '../reactivityKeys';
import { RuntimeClientAtom } from '../../runtime/RuntimeClient';
import { ProductsComparison } from '../../service/productsComparison/ProductsComparison';
import * as Atom from 'effect/unstable/reactivity/Atom';

/**
 * Product comparison atoms
 */

// Read current product codes from cookie (for checking if product is already in comparison)
export const productCodesInComparisonAtom = RuntimeClientAtom.atom(
  Effect.gen(function* () {
    const comparisonService = yield* ProductsComparison;
    return yield* comparisonService.getProductCodes;
  })
).pipe(Atom.withReactivity([reactivityKeys.productsComparison]), Atom.withServerValueInitial);

// Add product code to comparison (writes to cookie)
export const addProductCodeAtom = RuntimeClientAtom.fn(
  Effect.fn(function* (productCode: string) {
    const comparisonService = yield* ProductsComparison;

    yield* comparisonService.addProductCode(productCode);
  }),
  {
    reactivityKeys: [reactivityKeys.productsComparison],
  }
);

export const removeProductCodeAtom = RuntimeClientAtom.fn(
  Effect.fn(function* (productCode: string) {
    const comparisonService = yield* ProductsComparison;

    yield* comparisonService.removeProductCode(productCode);
  }),
  {
    reactivityKeys: [reactivityKeys.productsComparison],
  }
);

export const clearProductCodesAtom = RuntimeClientAtom.fn(
  Effect.fn(function* () {
    const comparisonService = yield* ProductsComparison;

    yield* comparisonService.clearProductCodes;
  }),
  {
    reactivityKeys: [reactivityKeys.productsComparison],
  }
);

export const reorderProductCodesAtom = RuntimeClientAtom.fn(
  Effect.fn(function* (productCodes: string[]) {
    const comparisonService = yield* ProductsComparison;

    yield* comparisonService.reorderProductCodes(productCodes);
  }),
  {
    reactivityKeys: [reactivityKeys.productsComparison],
  }
);
